// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"StatutesView_Wrapper__1WHbn","Image":"StatutesView_Image__3IWq1","Text":"StatutesView_Text__vGRmy"};